export default function(h) {
  return h(
    'pre',
    {
      class: this.$_class,
      domProps: { innerHTML: this.$_value }
    }
  )
}
